<template>
    <div class="fyt">
        <img src="@/static/music.png" :class="music ? 'music zhuan' : 'music'" @click="stopmusic" alt="" />
        <audio id="audio" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
        <div class="fyt-box">
            <img src="../static/fyt_bg.jpg" class="bg" alt="">

            <img src="../static/fyt_p1.png" class="fyt_p1" @click="openmp4box(1)" alt="">

            <img src="../static/fyt_p2.png" class="fyt_p2"  @click="openmp4box(2)" alt="">
            <img src="../static/fyt_p3.png" class="fyt_p3"  @click="openmp4box(3)" alt="">
            <img src="../static/fyt_p4.png" class="fyt_p4"  @click="openmp4box(4)" alt="">
            <img src="../static/fyt_p5.png" class="fyt_p5"  @click="openmp4box(5)" alt="">
            <img src="../static/fyt_p6.png" class="fyt_p6"  @click="openmp4box(6)" alt="">
            <img src="../static/fyt_p7.png" class="fyt_p7"  @click="openmp4box(7)" alt="">

            <img src="../static/fyt_p8.png" class="fyt_p8"  @click="openmp4box(8)" alt="">
            <img src="../static/fyt_p9.png" class="fyt_p9"  @click="openmp4box(9)" alt="">
            <img src="../static/fyt_p10.png" class="fyt_p10"  @click="openmp4box(10)" alt="">
            <img src="../static/fyt_p11.png" class="fyt_p11"  @click="openmp4box(11)" alt="">

            <img src="../static/fyt_p12.png" class="fyt_p12"  @click="openmp4box(12)" alt="">
            <img src="../static/fyt_p13.png" class="fyt_p13"  @click="openmp4box(13)" alt="">
            <img src="../static/fyt_p14.png" class="fyt_p14"  @click="openmp4box(14)" alt="">

            <img src="../static/fyt_p15.png" class="fyt_p15"  @click="openmp4box(15)" alt="">
            <img src="../static/fyt_p16.png" class="fyt_p16"  @click="openmp4box(16)" alt="">
            <img src="../static/fyt_p17.png" class="fyt_p17"  @click="openmp4box(17)" alt="">
            <img src="../static/fyt_p18.png" class="fyt_p18"  @click="openmp4box(18)" alt="">

            <!-- <img src="../static/fyt_p19.png" class="fyt_p19"  @click="openmp4box(19)" alt="">
            <img src="../static/fyt_p20.png" class="fyt_p20"  @click="openmp4box(20)" alt=""> -->
            <img src="../static/fyt_p21.png" class="fyt_p19"  @click="openmp4box(21)" alt="">
            <img src="../static/fyt_p22.png" class="fyt_p20"  @click="openmp4box(22)" alt="">
            <img src="../static/fyt_p23.png" class="fyt_p21"  @click="openmp4box(23)" alt="">
            <img src="../static/fyt_p24.png" class="fyt_p22"  @click="openmp4box(24)" alt="">
            <img src="../static/fyt_p25.png" class="fyt_p23"  @click="openmp4box(25)" alt="">

        </div>
        <div class="mp4-box" v-show="fyt_box">
            <video-player class="video-player vjs-custom-skin fyt-mp4" @ended="onPlayerEnded($event)"
                @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" ref="fyt_mp4" :playsinline="true"
                :options="fyt_mp4">
            </video-player>
            <img src="../static/fyt_back.png" class="fyt_back" @click="closemp4box" alt="">


        </div>
        <img src="../static/back.png" class="back" v-show="!fyt_box" @click="backletter" alt="">
    </div>
</template>

<script>
export default {
    data() {
        return {
            music: true,
            fyt_box: false,
            fyt_mp4: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                        src: require("../static/fyt_m1.mp4"), //url地址
                    },
                ],
                poster: "", //你的封面地址
                // width: document.documentElement.clientWidth, //播放器宽度
                notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true, // 当前时间和持续时间的分隔符
                    durationDisplay: true, // 显示持续时间
                    remainingTimeDisplay: true, // 是否显示剩余时间功能

                    fullscreenToggle: true, //全屏按钮
                },
            },
        }
    },
    methods: {
        stopmusic() {
            let audio = document.getElementById("audio");
            if (this.music == true) {
                this.music = false;
                audio.pause();

            } else {
                this.music = true;
                // audio.volume = 0.2;
                audio.play();
            }
        },
        backletter() {
            let audio = document.getElementById("audio");
            window.sessionStorage.setItem("time", audio.currentTime);
            window.sessionStorage.setItem("music", this.music);
            this.$router.push("map")
        },
          onPlayerPlay(e) {
      console.log("播放")

    },
    onPlayerPause(e) {
      console.log("暂停")
    },
    onPlayerEnded(e) {
      console.log("播放结束", e);
    },
    closemp4box(){
         this.fyt_box = false
      this.$refs.fyt_mp4.player.pause();
      let audio = document.getElementById("audio");
      if (this.music == true) {
        audio.play();
      } else {
        audio.pause();
      }
    },
    openmp4box(a){
         document.getElementById("audio").pause()
        this.fyt_mp4.sources[0].src = require("../static/fyt_m"+a+".mp4")
        this.fyt_box=true
             setTimeout(() => {
        this.$refs.fyt_mp4.player.play();
      }, 500)
    }
    },
    mounted() {
        let audio = document.getElementById("audio");

        if (window.sessionStorage.getItem("music") == "false") {
            this.music = false
            audio.pause();
        } else {


            if (window.sessionStorage.getItem("time") != "null") {

                audio.currentTime = window.sessionStorage.getItem("time")
                // audio.play()
            }

            audio.play()
        }
    },
}
</script>

<style lang="less" >
.fyt {
    width: 100%;
    position: relative;

    .music {
        position: fixed;
        top: 15px;
        right: 15px;
        width: 40px;
        z-index: 3;
        transform: rotate(250deg);

        &.zhuan {
            animation: turn 2s linear infinite;

            @keyframes turn {
                0% {
                    -webkit-transform: rotate(0deg);
                }

                25% {
                    -webkit-transform: rotate(90deg);
                }

                50% {
                    -webkit-transform: rotate(180deg);
                }

                75% {
                    -webkit-transform: rotate(270deg);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                }
            }
        }
    }

    .fyt-box {
        position: relative;

        .bg {
            width: 100%;
            display: block;
        }

        .fyt_p1 {
            position: absolute;
            width: 325px;
            top: 195px;
            left: 25px;
        }

        .fyt_p2 {
            position: absolute;
            width: 155px;
            top: 445px;
            left: 25px;
        }

        .fyt_p3 {
            position: absolute;
            width: 155px;
            top: 445px;
            left: 195px;
        }

        .fyt_p4 {
            position: absolute;
            width: 155px;
            top: 565px;
            left: 25px;
        }

        .fyt_p5 {
            position: absolute;
            width: 155px;
            top: 565px;
            left: 195px;
        }

        .fyt_p6 {
            position: absolute;
            width: 155px;
            top: 685px;
            left: 25px;
        }

        .fyt_p7 {
            position: absolute;
            width: 155px;
            top: 685px;
            left: 195px;
        }

        .fyt_p8 {
            position: absolute;
            width: 155px;
            top: 850px;
            left: 25px;
        }

        .fyt_p9 {
            position: absolute;
            width: 155px;
            top: 850px;
            left: 195px;
        }

        .fyt_p10 {
            position: absolute;
            width: 155px;
            top: 970px;
            left: 25px;
        }

        .fyt_p11 {
            position: absolute;
            width: 155px;
            top: 970px;
            left: 195px;
        }

        .fyt_p12 {
            position: absolute;
            width: 325px;
            top: 1140px;
            left: 25px;
        }

        .fyt_p13 {
            position: absolute;
            width: 325px;
            top: 1260px;
            left: 25px;
        }

        .fyt_p14 {
            position: absolute;
            width: 325px;
            top: 1380px;
            left: 25px;
        }

        .fyt_p15 {
            position: absolute;
            width: 325px;
            top: 1555px;
            left: 25px;
        }

        .fyt_p16 {
            position: absolute;
            width: 325px;
            top: 1675px;
            left: 25px;
        }

        .fyt_p17 {
            position: absolute;
            width: 325px;
            top: 1795px;
            left: 25px;
        }

        .fyt_p18 {
            position: absolute;
            width: 325px;
            top: 1915px;
            left: 25px;
        }

        .fyt_p19 {
            position: absolute;
            width: 325px;
            top: 2090px;
            left: 25px;
        }

        .fyt_p20 {
            position: absolute;
            width: 325px;
            top: 2210px;
            left: 25px;
        }

        .fyt_p21 {
            position: absolute;
            width: 325px;
            top: 2330px;
            left: 25px;
        }

        .fyt_p22 {
            position: absolute;
            width: 325px;
            top: 2450px;
            left: 25px;
        }

        .fyt_p23 {
            position: absolute;
            width: 325px;
            top: 2570px;
            left: 25px;
        }

        .fyt_p24 {
            position: absolute;
            width: 325px;
            top: 2690px;
            left: 25px;
        }

        .fyt_p25 {
            position: absolute;
            width: 310px;
            top: 2810px;
            left: 25px;
        }

    }

    .back {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 60%;
        left: 50%;
        z-index: 2;
        margin-left: -30%;
    }
    .mp4-box{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 20;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.811);
        overflow: hidden;
        .fyt_back{
            width: 80px;
            position: absolute;
            left: 0;
            top: 100px;

        }
        .fyt-mp4{
            position: absolute;
            top: 200px;
            left: 0px;
            width: 100%;
        }
        .video-js .vjs-big-play-button {
            top: 80px;
            left: 140px;
        }
    }
}
</style>
